/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


(function(){
    if(!this.GS) this.GS={};
    var TextEditor = this.GS.TextEditor=new Class({
       Implements:[Options],
       Logger:['log','error','warn','info','group','groupEnd','time','timeEnd','debug'],
       'class_name': 'GS.TextEditor',
       options:{},
       initialize:function(o){
           this.setOptions(o);
          
           var i=new nicEditor(o);
           i.addInstance=function(self){
              
               return  function(e,o) {
                    
                    e = this.checkReplace($BK(e));
                    //console.debug('AddInstance @niceEdit',e);
                    if( e.contentEditable || !!window.opera ) {
                            //self.console.log('Add new instance!');
                            var newInstance = new GS.EditorInstance(e,o,this);
                    } else {
                            var newInstance = new nicEditorIFrameInstance(e,o,this);
                    }
                    this.nicInstances.push(newInstance);
                    //console.debug('istances @niceEdit',this.nicInstances);
                    return this;
             };
           }(this);
           return i;
       } 
    });
    
    //nicEditor;
    var EditorInstance=this.GS.EditorInstance=new Class({
       Implements:[Options],
       Logger:['log','error','warn','info','group','groupEnd','time','timeEnd','debug'],
       'class_name': 'GS.EditorInstance',
       options:{
           'debug':1
       },
       initialize:function(e,o,cls){
           this.setOptions(o);
           
           
           
           nicEditorInstance.prototype.init=function(self){
              return function() {
                        this.elm.setAttribute('contentEditable','true');
                        //self.console.log('New EditorInstance add to:',this.elm);
                        if(this.getContent() != "") {}
                        this.instanceDoc = document.defaultView;
                        this.elm.addEvent('mousedown',this.selected.closureListener(this)).addEvent('keypress',this.keyDown.closureListener(this)).addEvent('focus',this.selected.closure(this)).addEvent('blur',this.blur.closure(this)).addEvent('keyup',this.selected.closure(this));
                        this.elm.addEvent('keydown',this.keyDown.closureListener(this));
                        this.ne.fireEvent('add',this);
                }
           }(this);
           
           nicEditorInstance.prototype.keyDown=function(self){
               return function(e,t) {
                
                    if(e.keyCode===13) return false;
                    
                    if(e.ctrlKey) {
                            this.ne.fireEvent('key',this,e);
                    }else{
                        this.ne.fireEvent('keydown',this,e);
                    }
                    
                    //return false;
                };
            }(this);
           var i=new nicEditorInstance(e,o,cls);
           return i;
       }
    });
    
   
}.call(this));